// Title, description and robots for each route, set at runtime.
// Personal pages (/r/..., /manage/..., /booking-confirmation, the old
// /<customer uuid> link) are noindex and get the brief's generic titles —
// never personal data.
// Link previews in WhatsApp/Facebook come from crawlers that don't run JS:
// they only ever see the defaults in public/index.html. Per-link og tags
// would need a hosting rewrite to a function that renders the head.

const SITE = "Tapes To Digital";

function setMeta(attr, key, content) {
  let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (content === null) {
    if (tag) tag.parentNode.removeChild(tag);
    return;
  }
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

// meta: { title, description, noindex }
export function applyPageMeta(meta = {}) {
  const title = meta.title ? `${meta.title} | ${SITE}` : SITE;
  document.title = title;
  setMeta("name", "robots", meta.noindex ? "noindex" : null);
  if (meta.description) {
    setMeta("name", "description", meta.description);
    setMeta("property", "og:description", meta.description);
  }
  setMeta("property", "og:title", title);
}
